{
  "Personel Listesi": "Personel Listesi",
  "İzin Rapor": "İzin Raporu",
  "personel": {
    "Ad Soyad": "Ad Soyad",
    "Adres": "Adres",
    "Aç": "Aç",
    "Açıklama": "Açıklama",
    "Banka": "Banka",
    "Banka Güncelle": "Banka Güncelle",
    "Başlangıç Tarih": "Başlangıç Tarih",
    "Belge Tür": "Belge Tür",
    "Bilgi Notu": "Bilgi Notu",
    "Bitiş Tarih": "Bitiş Tarih",
    "Bölüm": "Bölüm",
    "Cep": "Cep",
    "Cinsiyet": "Cinsiyet",
    "Dosya": "Dosya",
    "Dosya yok": "Dosya yok",
    "Dosyalar": "Dosyalar",
    "Doğum Tarih": "Doğum Tarih",
    "Doğum Tarihi": "Doğum Tarihi",
    "Durum": "Durum",
    "Düşünceler": "Düşünceler",
    "E-mail": "E-mail",
    "Evlilik Tarihi": "Evlilik Tarihi",
    "Eğitim": "Eğitim",
    "Fakülte": "Fakülte",
    "Form Yazdır": "Form Yazdır",
    "Gün Dakika": "Gün Dakika",
    "IBAN": "IBAN",
    "IndirGoruntule": "İndir/Görüntüle",
    "Is_Bas_Tar": "İşe Başlama Tarihi",
    "Izin Rapor": "Izin Rapor",
    "Kalan Ücretli İzin Günü": "Kalan Ücretli İzin Günü",
    "Kalan İzin": "Kalan İzin",
    "Kan Grubu": "Kan Grubu",
    "Kart No": "Kart No",
    "Kayıtlı aşama bulunamadı": "Kayıtlı aşama bulunamadı.",
    "Kimlik No": "Kimlik No",
    "Koordinat X (Enlem)": "Koordinat X (Enlem)",
    "Koordinat Y (Boylam)": "Koordinat Y (Boylam)",
    "Koordinat Çek": "Koordinat Çek",
    "Kullanıcı": "Kullanıcı",
    "Kurum/Okul": "Kurum/Okul",
    "Madde": "Madde",
    "Medeni Durum": "Medeni Durum",
    "Medeni Hal": "Medeni Hal",
    "Not": "Not",
    "Personel": "Personel",
    "Personel Dosyaları": "Personel Dosyaları",
    "Personel Listesi": "Personel Listesi",
    "Personel Profil": "Personel Profili",
    "Resim": "Resim",
    "Sicil No": "Sicil No",
    "Tarih": "Tarih",
    "Tarihi": "Tarihi",
    "Telefon": "Telefon",
    "Teslim Tarihi": "Teslim Tarihi",
    "Tüm Personel Dosyaları": "Tüm Personel Dosyaları",
    "Yakınlık": "Yakınlık",
    "Yemek Durum": "Yemek (Aktif/Pasif)",
    "Yemek Kart Tipi": "Yemek Kart Tipi",
    "Yeni Banka": "Yeni Banka",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Yenile": "Yenile",
    "Zimmet": "Zimmet",
    "diger": "Diğer",
    "kimlikno": "Kimlik No",
    "mazaret": "Mazeret",
    "rapor": "Rapor",
    "toplam": "Toplam",
    "ucretli": "Ücretli",
    "ucretsiz": "Ücretsiz",
    "Çocuk Sayısı": "Çocuk Sayısı",
    "Öğrenim": "Öğrenim",
    "Ürün": "Ürün",
    "İade Tarih": "İade Tarih",
    "İade Tarihi": "İade Tarihi",
    "İzin": "İzin",
    "İzin Hakediş Tar": "İzin Hakkı Kazanma Tarihi",
    "İzin Hakediş Tarihi": "İzin Hakediş Tarihi",
    "İzin Rapor": "İzin Raporu",
    "İzin Yenile": "İzin Yenile",
    "İzinli Gün": "İzinli Gün",
    "İş Başlangıç": "İş Başlangıç",
    "İş Başlangıç Tarihi": "İş Başlangıç Tarihi",
    "İş Bitiş": "İş Bitiş",
    "İş Bitiş Tarihi": "İş Bitiş Tarihi",
    "İş Giriş Aşamaları": "İş Giriş Aşamaları",
    "İş Çıkış Aşamaları": "İş Çıkış Aşamaları",
    "Şube": "Şube"
  }
}
